function PlacementIntelligence() {
  return (
    <section className="placement-intelligence">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Placement intelligence</div>
          <h2>
            <span className="intro-title-line">Better placements begin</span>
            <span className="intro-title-line">with better information.</span>
          </h2>
          <p>A clear, credible market presentation helps reinsurers understand the exposure, evaluate the opportunity and respond with greater confidence.</p>
        </div>
        <div className="placement-list">
          <article className="placement-item">
            <span className="placement-icon">
              <svg viewBox="0 0 24 24"><path d="M4 19V5h16v14zM8 15V9M12 15V7M16 15v-4" /></svg>
            </span>
            <div>
              <h3>A coherent portfolio story</h3>
              <p>We organise underwriting information around portfolio composition, performance, objectives and the rationale for the proposed structure.</p>
            </div>
            <b>→</b>
          </article>
          <article className="placement-item">
            <span className="placement-icon">
              <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" /><path d="m12 7 2 5-2 5-2-5zM4 12h4M16 12h4" /></svg>
            </span>
            <div>
              <h3>Clear exposure and accumulation detail</h3>
              <p>Risk characteristics, concentrations and catastrophe exposures are presented clearly to support technical assessment and capacity decisions.</p>
            </div>
            <b>→</b>
          </article>
          <article className="placement-item">
            <span className="placement-icon">
              <svg viewBox="0 0 24 24"><path d="M5 20V8M12 20V4M19 20v-9M3 20h18" /></svg>
            </span>
            <div>
              <h3>Claims information with context</h3>
              <p>Loss experience is reviewed alongside trends, material events and corrective actions so markets receive a balanced and useful picture.</p>
            </div>
            <b>→</b>
          </article>
          <article className="placement-item">
            <span className="placement-icon">
              <svg viewBox="0 0 24 24"><path d="M4 6h16v14H4zM8 3v6M16 3v6M4 11h16" /><path d="m9 16 2 2 4-4" /></svg>
            </span>
            <div>
              <h3>Preparedness for negotiation and renewal</h3>
              <p>Early planning, complete documentation and clear timelines create more room for market engagement, comparison and informed decisions.</p>
            </div>
            <b>→</b>
          </article>
        </div>
      </div>
    </section>
  )
}

export default PlacementIntelligence
